import { useTranslation } from 'react-i18next';
import { Logo1, Logo2, LogoWrapper, NavContainer, Links, LoginLink } from './NavbarComponents';

function NavbarComponent() {
  const { t, i18n } = useTranslation();

  const isFrench = i18n.language === 'fr';

  return (
    <>
      <NavContainer>
        <LogoWrapper>
          {isFrench ? (
            <>
              <Logo2 className="share-tech-regular" style={{ paddingLeft: '0.25rem' }}>technologies</Logo2>
              <Logo1 className="share-tech-regular" style={{ marginLeft: '0.5rem' }}>flagpole</Logo1>
            </>
          ) : (
            <>
              <Logo1 className="share-tech-regular">flagpole</Logo1>
              <Logo2 className="share-tech-regular">technologies</Logo2>
            </>
          )}
        </LogoWrapper>
        <Links>
          <button
            type="button"
            onClick={() => i18n.changeLanguage(isFrench ? 'en' : 'fr')}
            style={{
              background: 'transparent',
              border: '1px solid rgba(255,255,255,0.5)',
              color: '#fff',
              borderRadius: '999px',
              padding: '0.4rem 0.8rem',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            {isFrench ? 'EN' : 'FR'}
          </button>
          <LoginLink to="/login">{t('nav.login')}</LoginLink>
        </Links>
      </NavContainer>
    </>
  );
}

export default NavbarComponent;
